import React, { useEffect, useRef } from "react";
import classNames from "classnames";

import { ReactComponent as TopSvg } from "./top.svg";
import { ReactComponent as MiddleSvg } from "./middle.svg";
import { ReactComponent as BottomSvg } from "./bottom.svg";

import styles from "./StretchCastle.module.scss";
import { performantUpdate } from "../../../utils/dom";
import { clamp } from "../../../utils/utils";
import { useAppContext } from "../../Context/AppContext";

const StretchCastle: React.FC<{
  className?: string;
  heightElementSelector: string;
}> = ({ className, heightElementSelector }) => {
  const { animating } = useAppContext();
  const castleRef = useRef<HTMLDivElement | null>(null);
  const listening = useRef(false);

  useEffect(() => {
    if (animating || listening.current) {
      return;
    }

    listening.current = true;
    let hei = window.innerHeight;
    let castleY = castleRef.current?.offsetTop || 0;
    const heightMatch = document.querySelector<HTMLElement>(
      heightElementSelector
    );
    let maxHei = heightMatch?.getBoundingClientRect().height || 0;

    const resizeCb = performantUpdate(() => {
      hei = window.innerHeight;

      if (castleRef.current) {
        castleY = castleRef.current.offsetTop;
      }

      if (heightMatch) {
        maxHei = heightMatch.getBoundingClientRect().height;
      }
    });

    const cb = performantUpdate(() => {
      const y = window.pageYOffset;

      const posY = y + hei;

      if (posY > castleY) {
        castleRef.current?.style.setProperty(
          "--castle-height",
          `${clamp(posY - castleY, 0, maxHei) - 20}px`
        );
      }
    });

    window.addEventListener("scroll", cb, { passive: true });
    window.addEventListener("resize", resizeCb, { passive: true });

    return () => {
      window.removeEventListener("scroll", cb);
      window.removeEventListener("resize", resizeCb);
      listening.current = false;
    };
  }, [animating, heightElementSelector]);

  return (
    <div ref={castleRef} className={classNames(styles.wrap, className)}>
      <TopSvg className={classNames(styles.svg, styles.svgTop)} />
      <MiddleSvg
        className={classNames(styles.svg, styles.svgMiddle)}
        preserveAspectRatio="none"
      />
      <BottomSvg className={classNames(styles.svg, styles.svgBottom)} />
    </div>
  );
};

export { StretchCastle };
